import { Injectable } from '@angular/core';
import { EncryptionService } from './encryption.service';
import { AppConfig } from '../interfaces/app-config';
import { globalConfig } from '../global-config';
import { getEnvironment } from '../environment/environment';
import { ENV } from '../interfaces/interfaces';
import { ConfigProjectService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectConfigService {
  env:ENV = getEnvironment();
  private config!: AppConfig;

  constructor(
    private configProjectService: ConfigProjectService,
  ) {}

  private deepMerge(target: any, source: any): any {
    if (!target || typeof target !== 'object') {
      target = {};
    }

    for (const key of Object.keys(source)) {
      if (Array.isArray(source[key])) {
        // Reemplaza completamente los arrays
        target[key] = source[key];
      } else if (source[key] instanceof Object) {
        // Fusiona objetos recursivamente
        target[key] = this.deepMerge(target[key], source[key]);
      } else {
        // Asigna valores primitivos
        target[key] = source[key];
      }
    }

    return target;
  }

  async loadConfig(): Promise<any> {
    const globalConfig$ = Promise.resolve(globalConfig);
   // console.log('globalConfig', globalConfig);

    let selfPc = this.configProjectService.getAllConfig();
    //console.log('projectConfig', selfPc);
    const projectConfig$ = Promise.resolve(selfPc);

    return Promise.all([globalConfig$, projectConfig$]).then(([globalConfig, projectConfig]) => {
      // console.log(this.deepMerge(globalConfig, projectConfig || {}));
      this.config = this.deepMerge(globalConfig, projectConfig || {});
    });
  }

  getConfig(): AppConfig {
    return this.config;
  }
}
